import { Tooltip } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import { Close } from '@material-ui/icons'
import styled, { css, ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import { PrimaryButton, SecondaryButtonLight } from '../Button'

const styles = () => ({
  innerContainer: {
    minWidth: '360px',
  },
  topHeading: {
    padding: '32px',
  },
  topHeadingBorder: {
    borderBottom: '1px solid #ccc',
    position: 'sticky',
    top: '0',
    zIndex: '1',
    background: theme.colors.white,
  },
  crossIcon: {
    float: 'right',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  bottomBar: {
    borderTop: '1px solid #ccc',
    padding: 10,
  },
  labelContainer: {
    color: '#fff',
  },
  content: {
    padding: '36px',
  },
})

function handleClose(func, val) {
  func(val)
}

function handleSubmit(func, funcClose, onValidate, isSubmitWithOutClose) {
  if (typeof onValidate === 'function') {
    const isValid = onValidate()
    if (isValid) {
      func()
      if (!isSubmitWithOutClose) {
        funcClose()
      }
    }
  } else {
    func()
    if (!isSubmitWithOutClose) {
      funcClose()
    }
  }
}

function ModalFullScreen(props) {
  const {
    classes,
    okText,
    cancelText,
    customHeader,
    label,
    isOpen,
    handleModalClose,
    handleModalSubmit,
    handleValidate,
    isShowSaveButton,
    isShowBottomBar,
    isHideCancel,
    isError,
    isSubmitWithOutClose,
    backButton,
    cancelButton,
    nextButton,
    isWizard,
    ...rest
  } = props
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <Dialog
          open={isOpen}
          disableBackdropClick
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={() => {
            handleClose(handleModalClose, isOpen)
          }}
          fullScreen
          {...rest}
        >
          <ModalHeader>
            {customHeader || <ModalHeading>{label}</ModalHeading>}
            <Tooltip title="Close" placement="left">
              <CloseButton
                onClick={() => {
                  handleClose(handleModalClose, isOpen)
                }}
                aria-label="Close"
              >
                <Close />
              </CloseButton>
            </Tooltip>
          </ModalHeader>
          <DialogContent classes={{ root: classes.content }}>{props.children}</DialogContent>
          {isShowBottomBar && (
            <DialogFooter>
              <ActionButtons isWizard={isWizard}>
                <ButtonWrap>
                  {!isHideCancel && (
                    <SecondaryButtonLight
                      onClick={() => {
                        handleClose(handleModalClose, isOpen)
                      }}
                      aria-label={cancelText}
                    >
                      {cancelText}
                    </SecondaryButtonLight>
                  )}
                </ButtonWrap>
                <ButtonWrap>
                  {backButton && backButton}
                  {nextButton}
                  {isShowSaveButton && (
                    <PrimaryButton
                      onClick={() => {
                        handleSubmit(handleModalSubmit, handleModalClose, handleValidate, isSubmitWithOutClose)
                      }}
                      aria-label={okText}
                    >
                      {okText}
                    </PrimaryButton>
                  )}
                </ButtonWrap>
              </ActionButtons>
            </DialogFooter>
          )}
        </Dialog>
      </div>
    </ThemeProvider>
  )
}

ModalFullScreen.defaultProps = {
  okText: 'Save',
  cancelText: 'Cancel',
  isOpen: false,
  isShowBottomBar: true,
  titleBottomBorder: true,
  isError: false,
  label: '',
  isSubmitWithOutClose: false,
}

const ModalHeader = styled(DialogTitle)`
  && {
    background-color: ${props => props.theme.header.background};
    padding: 12px 12px 12px 24px;
    > * {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;
    }
  }
`

const CloseButton = styled(Button)`
  && {
    padding: 8px 10px;
    min-width: auto;
    color: ${props => props.theme.header.textColor};
  }
`

const ActionButtons = styled(DialogActions)`
  && {
    justify-content: space-between;
    ${props =>
      props.isWizard &&
      css`
        margin-right: 4rem;
      `}
  }
`

const ButtonWrap = styled.div`
  button {
    margin: 0 5px;
  }
`

const ModalHeading = styled.div`
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1;
  color: ${`var(--gameday-body-headingColor, ${theme.body.headingColor})`};
`

const DialogFooter = styled.div`
  background-color: ${props => props.theme.colors.slate};
  padding: 5px 12px;
  border-top: ${theme.borders.default};
`

const ModalComponent = withStyles(styles)(ModalFullScreen)
ModalComponent.displayName = 'ModalFullScreen'
export default ModalComponent
